import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Input } from '../../../components/input'
import { Header } from '../../../components/header'
import { Button } from '../../../components/button'
import { Footer } from '../../../components/footer'
import sickPerson from '../../../assets/images/medium-shot-sick-woman-home.jpg'
import './style.css'

export function LoginPaciente() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  })

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    alert('Login realizado com sucesso!')
    // Handle login logic here
  }

  return (
    <div className="login-page">
      <Header />
      
      <main className="login-main">
        <div className="login-container">
          <div className="login-grid">
            <div className="image-section">
              <div className="image-card">
                <img src={sickPerson} alt="Portal Paciente" className="login-image" />
              </div>
            </div>

            <div className="form-section">
              <div className="login-content">
                <div className="page-header">
                  <h1 className="page-title">Meu VidaPlus</h1>
                  <p className="page-subtitle">Portal Paciente</p>
                </div>

                <form className="login-form" onSubmit={handleSubmit}>
                <Input 
                  Text="E-mail"
                  htmlFor="email"
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="seu.email@exemplo.com"
                />

                <Input 
                  Text="Senha"
                  htmlFor="password"
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Digite sua senha" 
                />

                  <div className="checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="rememberMe"
                        checked={formData.rememberMe}
                        onChange={handleChange}
                        className="checkbox-input"
                      />
                      <span>Permanecer conectado</span>
                    </label>
                  </div>

                  <Button textBody="Entrar" type="submit" />

                  <div className="help-links">
                    <p className="help-text">
                      Precisa de ajuda? <Link to="/contato" className="link">Clique aqui.</Link>
                    </p>
                    <p className="help-text">
                      <Link to="#" className="link">Esqueci minha senha</Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
